import React from 'react';
import { ArrowRight, MapPin, Phone, Star } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative isolate flex min-h-[620px] w-full items-center overflow-hidden bg-slate-950" data-id="element-97" data-mp="ejmr5f3rdrxe">
      <img src="https://cdn.magicpatterns.com/uploads/k1VvAPjF1r3vHJewuFDhpg/plumb-hero.jpg" alt="" className="absolute inset-0 -z-20 h-full w-full object-cover object-center" data-id="element-98" data-mp="9llat1xpw6pm" />
      <div className="absolute inset-0 -z-10 bg-slate-950/75" aria-hidden="true" data-id="element-99" data-mp="128yye9fizpx2" />

      <div className="mx-auto w-full max-w-6xl px-4 py-20 sm:px-6 lg:py-28" data-id="element-100" data-mp="xbfht2vcv11y">
        <div className="max-w-2xl" data-id="element-101" data-mp="sart4nulmwaw">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-3 py-1 text-xs font-semibold text-white" data-id="element-102" data-mp="s9q8psrp0xgi">
            <Star className="h-3.5 w-3.5 fill-sky-300 text-sky-300" data-id="element-103" data-mp="3d1a4l90jrr80" />
            Trusted local plumbers in Arizona
          </span>

          <h1 className="mt-5 font-heading text-4xl font-bold tracking-tight text-white [text-shadow:0_2px_12px_rgba(2,6,23,0.9)] sm:text-5xl lg:text-6xl" data-id="element-104" data-mp="381nv9anuav4h">
            We&apos;ll get your <span className="text-sky-300" data-id="element-105" data-mp="3o7vk1k75dnxa">water flowing</span>
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-100 [text-shadow:0_1px_8px_rgba(2,6,23,0.9)]" data-id="element-106" data-mp="39acuwgqk58pb">
            Fast-response repairs, reliable service, and professional workmanship. From emergency
            fixes to full installs — done right the first time.
          </p>

          <div className="mt-6 flex items-center gap-2 text-sm font-medium text-slate-100 [text-shadow:0_1px_8px_rgba(2,6,23,0.9)]" data-id="element-107" data-mp="358rdci32w68s">
            <MapPin className="h-4 w-4 text-sky-300" data-id="element-108" data-mp="2qkwk90l5rzv6" />
            Serving Phoenix, Casa Grande &amp; Tucson
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-109" data-mp="2vjga3c2vhvst">
            <a href="tel:5203000690" className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-slate-900 transition-colors hover:bg-sky-50" data-id="element-110" data-mp="2hix2g62bkrr6">
              <Phone className="h-4 w-4" data-id="element-111" data-mp="s3cm2bn71lr3" />
              Call now: 520-300-0690
            </a>
            <a href="#services" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/50 bg-white/10 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/20" data-id="element-112" data-mp="na08cwk1yzd4">
              View services
              <ArrowRight className="h-4 w-4" data-id="element-113" data-mp="1b0dsm0webtx5" />
            </a>
          </div>
        </div>

        <div className="mt-12 inline-flex items-center gap-3 rounded-2xl border border-white/20 bg-white/95 px-4 py-3 shadow-lg sm:absolute sm:bottom-8 sm:right-6 lg:right-12" data-id="element-114" data-mp="16344cokqtoaw">
          <div className="flex" data-id="element-115" data-mp="x1w6u8q1wrhv">
            {[...Array(5)].map((_, index) => <Star key={index} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-116" data-mp="3lsoyezdi9t7k" data-mpi={index} />)}
          </div>
          <div className="text-xs" data-id="element-117" data-mp="3hr3sjxze2f6v">
            <p className="font-semibold text-slate-900" data-id="element-118" data-mp="3hq250u16s089">5.0 rating</p>
            <p className="text-slate-500" data-id="element-119" data-mp="1xacfx49qzltr">Loved on Google</p>
          </div>
        </div>
      </div>
    </section>;
}